import { useAdDetails } from './useAdDetails';
import { useServerDataContext } from '@/contexts';

export function useIsAuthor({ cacheOnly = false } = {}) {
  const { adDetails } = useAdDetails({ cacheOnly });
  const { initialAdDetails } = useServerDataContext();

  const adData = adDetails ?? initialAdDetails;

  return Boolean(adData?.isAuthor);
}
